/** @type {Styles} */

export const styles = {
  navigationLinkContainer: {
    paddingLeft: 0,
    marginLeft: -1,
    height: 64,
  },
  navigationButton: {
    paddingLeft: 0,
    marginBottom: 2,
  },
  angleLeftIcon: {
    marginRight: 0.5,
    marginLeft: -0.5,
  },
}
